// Dim background when header dropdown is open
document.addEventListener('DOMContentLoaded', function() {
  const mainContent = document.getElementById('MainContent');
  const menuItems = document.querySelectorAll('.menu-list__list-item');
  
  if (!mainContent || !menuItems.length) return;

  menuItems.forEach(function(item) {
    item.addEventListener('pointerenter', function() {
      // Only dim if this item has a submenu
      if (item.querySelector('.menu-list__submenu')) {
        mainContent.style.filter = 'brightness(0.75)';
        mainContent.style.transition = 'filter 0.3s ease';
      }
    });

    item.addEventListener('pointerleave', function() {
      mainContent.style.filter = 'brightness(1)';
    });
  });
});

// Dropdown overflow prevention for Horizon mega menu
window.addEventListener('load', () => {
  let topSubMenus = document.querySelectorAll('.header-menu .menu-list__submenu');

  let checkMenus = () => {
    if (window.innerWidth < 750) return;
    topSubMenus.forEach(e => {
      let p = e.parentElement;
      let er = e.getBoundingClientRect();
      let pr = p.getBoundingClientRect();
      if ((pr.left + er.width) > window.innerWidth) {
        e.classList.add('at-right');
      } else {
        e.classList.remove('at-right');
      }
    });
  };

  let debounceTimeout;
  setTimeout(checkMenus, 300);
  window.addEventListener('resize', () => {
    if (debounceTimeout) clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(checkMenus, 300);
  });
});

if (window.location.search.includes('open_cart=true')) {
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
      var cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer) {
        cartDrawer.open();
      }
      // Clean up URL
      var url = new URL(window.location);
      url.searchParams.delete('open_cart');
      window.history.replaceState({}, '', url.toString());
    }, 150);
  });
}

(function() {
  var triggers = document.querySelectorAll('.menu-list__list-item');

  triggers.forEach(function(item) {
    var link = item.querySelector('.menu-list__link');
    if (!link) return;

    link.addEventListener('click', function(e) {
      var hasSubmenu = item.querySelector('.menu-list__submenu');
      if (!hasSubmenu) return;
      e.preventDefault();
      item.classList.add('mb-force-open');
    });

    item.addEventListener('mouseleave', function() {
      item.classList.remove('mb-force-open');
    });
  });
})();

// ============================================================
// MEDBOUND PRODUCT PAGE — BUTTONS + STICKY BAR
// ============================================================
(function () {

  if (!document.querySelector('.mb-native-buttons')) return;

  // ---- Get variant ID (async, fetches product JSON) ----
  function getVariantId(callback) {
    var pathParts = window.location.pathname.split('/');
    var productIndex = pathParts.indexOf('products');
    if (productIndex === -1) return;
    var handle = pathParts[productIndex + 1];
    if (!handle) return;

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var variantId = product.selected_or_first_available_variant
          ? product.selected_or_first_available_variant.id
          : product.variants[0].id;
        callback(variantId);
      })
      .catch(function (err) {
        console.error('Could not fetch product JSON:', err);
      });
  }

  // ---- Core add to cart + cart drawer refresh ----
  function doAddToCart(btnEl, onSuccess) {
    getVariantId(function (variantId) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              data: {
                itemCount: cart.item_count,
                source: 'product-form-component'
              }
            }
          })
        );
        if (onSuccess) onSuccess();
      })
      .catch(function (err) {
        console.error('Cart add failed:', err);
        if (btnEl) {
          btnEl.disabled = false;
          btnEl.style.opacity = '';
        }
      });
    });
  }

  // ---- Wire native ATC buttons ----
  var nativeAtcBtns = document.querySelectorAll('.mb-native-atc');
  nativeAtcBtns.forEach(function (btn) {
    var originalHTML = btn.innerHTML;
    btn.addEventListener('click', function () {
      btn.classList.add('mb-native-atc--added');
      btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg> Added!';
      doAddToCart(btn, null);
      setTimeout(function () {
        btn.classList.remove('mb-native-atc--added');
        btn.innerHTML = originalHTML;
      }, 2200);
    });
  });

  // ---- Wire native Buy It Now buttons ----
  var nativeBuyBtns = document.querySelectorAll('.mb-native-buy');
  nativeBuyBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.disabled = true;
      btn.style.opacity = '0.7';
      getVariantId(function (variantId) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          console.error('Buy it now failed:', err);
          btn.disabled = false;
          btn.style.opacity = '';
        });
      });
    });
  });

  // ---- Back button fix ----
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      document.querySelectorAll('.mb-native-buy, .mb-sticky__buy').forEach(function (btn) {
        btn.disabled = false;
        btn.style.opacity = '';
      });
    }
  });

  // ============================================================
  // STICKY BAR — built after native buttons are wired
  // ============================================================
  var bar = document.createElement('div');
  bar.id = 'mb-sticky-bar';
  bar.innerHTML = [
    '<div class="mb-sticky__left">',
      '<img class="mb-sticky__img" src="" alt="" />',
      '<div class="mb-sticky__info">',
        '<span class="mb-sticky__title"></span>',
        '<div class="mb-sticky__price-wrap">',
          '<span class="mb-sticky__price-sale"></span>',
          '<span class="mb-sticky__price-compare"></span>',
        '</div>',
      '</div>',
    '</div>',
    '<div class="mb-sticky__right">',
      '<button class="mb-sticky__atc" type="button">',
        '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none">',
          '<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M16.608 9.421V6.906H3.392v8.016c0 .567.224 1.112.624 1.513.4.402.941.627 1.506.627H8.63M8.818 3h2.333c.618 0 1.212.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.344c0-.622.246-1.218.683-1.658A2.33 2.33 0 0 1 8.82 3"/>',
          '<path stroke="currentColor" stroke-linecap="round" stroke-width="1.8" d="M14.608 12.563v5m2.5-2.5h-5"/>',
        '</svg> Add to Cart',
      '</button>',
      '<button class="mb-sticky__buy" type="button">',
        '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">',
          '<path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>',
        '</svg> Buy It Now',
      '</button>',
    '</div>'
  ].join('');
  document.body.appendChild(bar);

  // ---- Populate image ----
  var heroImg = document.querySelector(
    '.product-media-container img, .product__media img, [data-testid="product-media"] img, .product-media img'
  );
  var stickyImg = bar.querySelector('.mb-sticky__img');
  if (heroImg) {
    stickyImg.src = heroImg.src.replace(/width=\d+/, 'width=240');
    stickyImg.alt = heroImg.alt || '';
  }

  // ---- Populate title ----
  var titleEl = document.querySelector('.product-details h1');
  if (titleEl) bar.querySelector('.mb-sticky__title').textContent = titleEl.textContent.trim();

  // ---- Populate price ----
  function updateStickyPrice() {
    var productPriceEl = document.querySelector('product-price');
    if (!productPriceEl) return;
    var saleEl = productPriceEl.querySelector('.price-item--sale');
    var compareEl = productPriceEl.querySelector('.price-item--regular.compare-at-price');
    var stickyS = bar.querySelector('.mb-sticky__price-sale');
    var stickyC = bar.querySelector('.mb-sticky__price-compare');
    if (saleEl) stickyS.textContent = saleEl.textContent.trim();
    if (compareEl) {
      var compareText = compareEl.textContent.trim();
      var saleText = saleEl ? saleEl.textContent.trim() : '';
      if (compareText && compareText !== saleText) {
        stickyC.textContent = compareText;
        stickyC.style.display = '';
      } else {
        stickyC.style.display = 'none';
      }
    }
  }
  updateStickyPrice();

  // ---- Wire sticky ATC (declared after bar is built) ----
  var stickyAtcBtn = bar.querySelector('.mb-sticky__atc');
  var stickyAtcOriginalHTML = stickyAtcBtn.innerHTML;

  stickyAtcBtn.addEventListener('click', function () {
    stickyAtcBtn.classList.add('mb-sticky__atc--added');
    stickyAtcBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg> Added!';
    doAddToCart(stickyAtcBtn, null);
    setTimeout(function () {
      stickyAtcBtn.classList.remove('mb-sticky__atc--added');
      stickyAtcBtn.innerHTML = stickyAtcOriginalHTML;
    }, 2200);
  });

  // ---- Wire sticky Buy It Now (declared after bar is built) ----
  var stickyBuyBtn = bar.querySelector('.mb-sticky__buy');

  stickyBuyBtn.addEventListener('click', function () {
    stickyBuyBtn.disabled = true;
    stickyBuyBtn.style.opacity = '0.7';
    getVariantId(function (variantId) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        console.error('Sticky buy now failed:', err);
        stickyBuyBtn.disabled = false;
        stickyBuyBtn.style.opacity = '';
      });
    });
  });

  // ---- Scroll trigger ----
  function checkScroll() {
    var block = document.querySelector('.mb-native-buttons');
    if (!block) return;
    var rect = block.getBoundingClientRect();
    bar.classList.toggle('mb-sticky--visible', rect.bottom < 0);
  }

  window.addEventListener('scroll', checkScroll, { passive: true });
  checkScroll();

  // ---- Rating count reformat ----
  function fixRatingCount() {
    document.querySelectorAll('.rating-wrapper .rating-count').forEach(function (el) {
      if (el.dataset.reformatted) return;
      var match = el.textContent.trim().match(/\d+/);
      if (match) {
        el.textContent = '(' + match[0] + ')';
        el.dataset.reformatted = 'true';
      }
    });
  }
  setTimeout(fixRatingCount, 600);

  if (window.innerWidth <= 900) {
    var galleryRoot = document.querySelector('media-gallery');
    if (galleryRoot) {
      var slideshowContainer = galleryRoot.querySelector('slideshow-container');
      var nextControl = galleryRoot.querySelector('slideshow-arrows .slideshow-control--next');
      var prevControl = galleryRoot.querySelector('slideshow-arrows .slideshow-control--previous');
      var thumbnails = galleryRoot.querySelectorAll('button.slideshow-controls__thumbnail');

      // Disable native zoom-on-tap by stripping the on:click directive
      // itself, rather than trying to intercept the click event — Horizon's
      // framework likely delegates from an ancestor, so removing the
      // attribute it reads at click-time is more reliable than racing it.
      galleryRoot.querySelectorAll('[on\\:click*="zoom-dialog"]').forEach(function (slide) {
        slide.removeAttribute('on:click');
      });

      if (slideshowContainer && nextControl && prevControl && thumbnails.length) {
        if (window.getComputedStyle(slideshowContainer).position === 'static') {
          slideshowContainer.style.position = 'relative';
        }

        var prevBtn = document.createElement('button');
        prevBtn.className = 'mb-gallery-arrow mb-gallery-arrow--prev';
        prevBtn.type = 'button';
        prevBtn.setAttribute('aria-label', 'Previous image');
        prevBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';

        var nextBtn = document.createElement('button');
        nextBtn.className = 'mb-gallery-arrow mb-gallery-arrow--next';
        nextBtn.type = 'button';
        nextBtn.setAttribute('aria-label', 'Next image');
        nextBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';

        slideshowContainer.appendChild(prevBtn);
        slideshowContainer.appendChild(nextBtn);

        function getActiveSlideImage() {
          var activeSlide = galleryRoot.querySelector('slideshow-slide[aria-hidden="false"]');
          return activeSlide ? activeSlide.querySelector('img') : null;
        }

        // Double requestAnimationFrame: the browser must actually paint the
        // "entering" (scaled-up) state before we remove the class, or both
        // style changes get batched into a single frame and no transition
        // is ever visible. This was the bug — a single rAF wasn't enough.
        function triggerZoomEntrance() {
          var img = getActiveSlideImage();
          if (!img) return;
          img.classList.remove('mb-gallery-entering');
          void img.offsetHeight;
          img.classList.add('mb-gallery-entering');
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              img.classList.remove('mb-gallery-entering');
            });
          });
        }

        // Trigger directly from our own clicks (doesn't depend on guessing
        // Horizon's internal timing), plus a MutationObserver fallback below
        // so native swipe gestures (which don't go through our buttons) also
        // fire the effect.
        prevBtn.addEventListener('click', function () {
          prevControl.click();
          setTimeout(triggerZoomEntrance, 50);
        });
        nextBtn.addEventListener('click', function () {
          nextControl.click();
          setTimeout(triggerZoomEntrance, 50);
        });

        var currentIndex = 0;
        thumbnails.forEach(function (thumb, i) {
          if (thumb.getAttribute('aria-selected') === 'true') currentIndex = i;
        });
        prevBtn.classList.toggle('mb-gallery-arrow--visible', currentIndex > 0);

        var thumbObserver = new MutationObserver(function (mutations) {
          mutations.forEach(function (m) {
            if (m.attributeName === 'aria-selected' && m.target.getAttribute('aria-selected') === 'true') {
              var idx = Array.prototype.indexOf.call(thumbnails, m.target);
              if (idx === -1) return;
              currentIndex = idx;
              prevBtn.classList.toggle('mb-gallery-arrow--visible', currentIndex > 0);
              triggerZoomEntrance();
            }
          });
        });
        thumbnails.forEach(function (thumb) {
          thumbObserver.observe(thumb, { attributes: true, attributeFilter: ['aria-selected'] });
        });

        var hasEnteredOnce = false;
        var entranceObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && !hasEnteredOnce) {
              hasEnteredOnce = true;
              triggerZoomEntrance();
              entranceObserver.disconnect();
            }
          });
        }, { threshold: 0.3 });
        entranceObserver.observe(galleryRoot);
      }
    }
  }
})();

(function() {
  function replaceDesktopArrows() {
    var prevSvg = document.querySelector('.slideshow-control--previous .icon-arrow svg');
    var nextSvg = document.querySelector('.slideshow-control--next .icon-arrow svg');
    var caretShape = '<polyline points="9 18 15 12 9 6" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></polyline>';

    if (prevSvg && !prevSvg.dataset.replaced) {
      prevSvg.innerHTML = caretShape;
      prevSvg.setAttribute('viewBox', '0 0 24 24');
      prevSvg.dataset.replaced = 'true';
    }
    if (nextSvg && !nextSvg.dataset.replaced) {
      nextSvg.innerHTML = caretShape;
      nextSvg.setAttribute('viewBox', '0 0 24 24');
      nextSvg.dataset.replaced = 'true';
    }
  }

  function hidePrevOnFirstSlide() {
    var slides = document.querySelectorAll('.product-information__media .slideshow-slide');
    var prevButton = document.querySelector('.slideshow-control--previous');
    if (!slides.length || !prevButton) return;

    var firstSlideActive = slides[0].getAttribute('aria-hidden') === 'false';
    prevButton.style.opacity = firstSlideActive ? '0' : '1';
    prevButton.style.pointerEvents = firstSlideActive ? 'none' : 'auto';
  }

  replaceDesktopArrows();
  hidePrevOnFirstSlide();

  var observer = new MutationObserver(function() {
    replaceDesktopArrows();
    hidePrevOnFirstSlide();
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
})();